'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Drawer = require('../../../../common/components/layout/Drawer.js');
var SecondaryButton = require('../../../../common/components/SecondaryButton.js');
var MobileDrawerPackageDetails = require('../../../../common/components/MobileDrawerPackageDetails.js');
var Button = require('@narvar/nth-block-button');
var index = require('../../../../common/providers/ClaimBuilder/index.js');
var PackageRemoveConfirmationForm = require('../../../../common/views/PackageRemoveConfirmation/PackageRemoveConfirmationForm.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var PackageRemoveConfirmationProvider = require('../../../../common/views/PackageRemoveConfirmation/PackageRemoveConfirmationProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const PackageRemoveConfirmationMobile = () => {
  const {
    state: {
      currency
    }
  } = index.useClaimBuilder();
  const {
    claimsButtonBack,
    claimsButtonNext,
    claimsRemovePackageTitle
  } = nthHookTranslations.useTranslations();
  const {
    packageDetails,
    claimDetails,
    state,
    onRemove,
    onCancel
  } = PackageRemoveConfirmationProvider.usePackageRemoveConfirmation();
  return /*#__PURE__*/React__default["default"].createElement(Drawer.Drawer, {
    onDismiss: onCancel,
    dismissText: "dismissPackageRemoveConfirm"
  }, /*#__PURE__*/React__default["default"].createElement(Drawer.DrawerHeader, {
    title: claimsRemovePackageTitle
  }), /*#__PURE__*/React__default["default"].createElement(Drawer.DrawerContent, null, /*#__PURE__*/React__default["default"].createElement(PackageRemoveConfirmationForm["default"], null)), /*#__PURE__*/React__default["default"].createElement(Drawer.DrawerFooter, null, /*#__PURE__*/React__default["default"].createElement(MobileDrawerPackageDetails["default"], {
    currency: currency,
    packageDetails: packageDetails,
    claimDetails: claimDetails
  }), /*#__PURE__*/React__default["default"].createElement(Drawer.DrawerActions, null, /*#__PURE__*/React__default["default"].createElement(SecondaryButton["default"], {
    big: true,
    onClick: onCancel
  }, claimsButtonBack), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    onClick: onRemove,
    disabled: !state
  }, claimsButtonNext))));
};
var PackageRemoveConfirmationMobile$1 = nthHookTranslations.withTranslationsProvider(PackageRemoveConfirmationMobile, {
  translationKeys: ['claimsButtonBack', 'claimsButtonNext', 'claimsRemovePackageTitle']
});

exports["default"] = PackageRemoveConfirmationMobile$1;
